import { createClient } from '@supabase/supabase-js';
import type { Database } from '@threadheads/shared';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error('Missing required Supabase environment variables. Please check your .env file.');
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Auth options are pinned explicitly so behavior doesn't drift if @supabase/supabase-js
// changes its defaults. All three values below match the current library default —
// this is a no-op that documents intent. storageKey and flowType are intentionally
// NOT set: Supabase derives storageKey from the project ref (changing it would
// invalidate every persisted session), and flowType affects OAuth handshakes whose
// behavior we don't want to alter from the project's existing dashboard config.
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
